// services/api/authService.js

const API_URL =
  process.env.REACT_APP_NODE_BACKEND_URL || "http://localhost:3000";

const API_KEY = process.env.REACT_APP_API_KEY;

// Signup
const signup = async (data) => {
  try {
    const response = await fetch(`${API_URL}/auth/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": API_KEY, // optional if your backend uses it
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || "Signup failed");
    }

    return result;
  } catch (error) {
    throw error;
  }
};

// Login
const login = async (data) => {
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": API_KEY,
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || "Login failed");
    }

    // Save ID token in localStorage for authenticated requests
    localStorage.setItem("idToken", result.idToken);

    return result; // includes idToken, refreshToken, and user data
  } catch (error) {
    throw error;
  }
};

// Get Profile (protected)
const getProfile = async () => {
  const token = localStorage.getItem("idToken");
  if (!token) throw new Error("Not authenticated");

  const response = await fetch(`${API_URL}/auth/profile`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || "Failed to fetch profile");
  return result;
};

const logout = () => {
  localStorage.removeItem("idToken");
};

const getToken = () => localStorage.getItem("idToken");

export default {
  signup,
  login,
  logout,
  getToken,
  getProfile,
};
